require('./style.scss')
angular = require('angular')
pkg = angular
  .module 'cdms.company', [
    require('angular-ui-router')
    require('./details')
  ]
  .config ($stateProvider) ->
    $stateProvider
      .state 'companies',
        url: "/companies"
        template: require('./index.pug')
        # controller: 'CompanyCtrl'
        authenicate: true
  # .controller('CompanyCtrl', require("./controller"))
  .factory('Company', require("./company"))
  .directive "companyManager", require('./manager')

module.exports = pkg.name



// WEBPACK FOOTER //
// ./src/component/company/index.coffee